import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

// 观众下单接口
export function addOrder(data) {
  return request({
    url: BASEROOT + '/intention/addOrder',
    method: 'post',
    data
  })
}

// 我的意向订单列表
export function getOwnOrder(data) {
  return request({
    url: BASEROOT + '/intention/getOwnOrder',
    method: 'post',
    data
  })
}

// 展商获取全部意向订单
export function getOrderPage(data) {
  return request({
    url: BASEROOT + '/intention/getOrderPage',
    method: 'post',
    data
  })
}


// 获取订单详情接口
export function getOrderDetail(data) {
  return request({
    url: BASEROOT + '/intention/getOrderDetail',
    method: 'post',
    data
  })
}



// 获取员工列表
export function getEmployeeList(data) {
  return request({
    url: BASEROOT + '/intention/getEmployeeList',
    method: 'post',
    data
  })
}

// 为订单分配员工
export function assignEmployee(data) {
  return request({
    url: BASEROOT + '/intention/assignEmployee',
    method: 'post',
    data
  })
}

// 意向订单删除
export function delOrder(data) {
  return request({
    url: BASEROOT + '/intention/delOrder',
    method: 'post',
    data
  })
}



// 观众修改意向订单状态
export function changeOrderStatus(data) {
  return request({
    url: BASEROOT + '/intention/changeOrderStatus',
    method: 'post',
    data
  })
}


// 导出意向订单
export function exportOrder(data) {
  return request({
    url: BASEROOT + '/intention/exportOrder',
    method: 'post',
    data
  })
}